import insertInArrayIf from '@zola-helpers/client/dist/es/util/insertInArrayIf';

import ArchShape from '~/assets/images/invitations/paper-shapes/arch.svg';
import DiamondShape from '~/assets/images/invitations/paper-shapes/diamond.svg';
import RoundedShape from '~/assets/images/invitations/paper-shapes/rounded.svg';
import ScallopedShape from '~/assets/images/invitations/paper-shapes/scalloped.svg';
import SquaredShape from '~/assets/images/invitations/paper-shapes/square.svg';
import TicketShape from '~/assets/images/invitations/paper-shapes/ticket.svg';
import HalfArchShape from '~/assets/images/invitations/paper-shapes/halfArch.svg';
import OvalShape from '~/assets/images/invitations/paper-shapes/oval.svg';

import featureFlags from '~/util/featureFlags';

export const CARD_SHAPE_FILTERS = [
  {
    value: 'square',
    label: featureFlags.get('squarePaperOrientation') ? 'Standard' : 'Square',
    icon: SquaredShape,
  },
  {
    value: 'rounded',
    label: 'Rounded',
    icon: RoundedShape,
  },
  {
    value: 'scalloped',
    label: 'Scalloped',
    icon: ScallopedShape,
  },
  ...insertInArrayIf(featureFlags.get('newPaperShapes'), {
    value: 'half-arch',
    label: 'Half-arch',
    icon: HalfArchShape,
  }),
  {
    value: 'arch',
    label: 'Arch',
    icon: ArchShape,
  },
  ...insertInArrayIf(featureFlags.get('newPaperShapes'), {
    value: 'oval',
    label: 'Oval',
    icon: OvalShape,
  }),
  {
    value: 'ticket',
    label: 'Ticket',
    icon: TicketShape,
  },
  {
    value: 'diamond',
    label: 'Diamond',
    icon: DiamondShape,
  },
] as const;
